import { createRoleThunks } from "./roleSliceFactory";
import { BUYER_ENDPOINTS, ROLE_COLLECTION_KEYS } from "../types/roles";

const slice = createRoleThunks(
  "buyer",
  BUYER_ENDPOINTS,
  ROLE_COLLECTION_KEYS.buyer
);

export const buyerThunks = {
  fetchResource: slice.fetchResource,
  createResource: slice.createResource,
  updateResource: slice.updateResource,
  runAction: slice.runAction,
};

export const buyerActions = slice.actions;

export default slice.reducer;
